import React, { useState, useEffect } from 'react'
import { toast } from "react-toastify";
import { backendApi } from '../../../api/apiService';

function DepartmentPopUp({ onclose, onload, id, name }) {
    const [Designation, setDesignation] = useState("");
    useEffect(() => {
        if (name) {
            setDesignation(name);
        }
    }, [name]);

    const DesignationUpdate = () => {
        if (Designation === "") {
            toast.warn("Please enter an Department:", { containerId: "F" });
            return false;
        }
        var req = {
            functionName: "departmentProjectEditUpdate",
            // site_id: localStorage.getItem("siteId"),
            departmentOrProject: Designation,
            updated_by: localStorage.getItem("userId"),
            id: id
        };
        backendApi(req).then((response) => {
            console.log(response);
            if (response.success == 1) {
                toast.success("Saved successsfully", { containerId: "D" });
                onclose();
                onload();
            } else {
                toast.warn("Error Saving status.", { containerId: "F" });
                return false;
            }
        });
    }
    const DesignationSave = () => {
        if (Designation === "") {
            toast.warn("Please enter an Designation:", { containerId: "F" });
            return false;
        }
        var req = {
            functionName: "departmentProjectSave",
            site_id: localStorage.getItem("siteId"),
            departmentOrProject: Designation,
            created_by: localStorage.getItem("userId")
        };
        backendApi(req).then((response) => {
            console.log(response);
            if (response.success == 1) {
                toast.success("Saved successsfully", { containerId: "D" });
                onclose();
                onload();
            } else {
                toast.warn("Error Saving status.", { containerId: "F" });
                return false;
            }
        });

    }

    return (
        <div className="modal_parent">
            <div className="module_popup addPeople bfAddPeople">
                <div className="module_innerpopup module_bodypop">
                    <div className="module_headdiv">
                        <h4 className="popup_head mb-2">New Department</h4>
                    </div>
                    <div className="module_body" style={{ overflowX: "hidden" }}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="input-group input-group-outline mb-2 location_search">
                                    <label htmlFor="" className="form-label">
                                        Department
                                    </label>
                                    <div className="col-md-12 p-0 position-relative">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Department..."
                                            value={Designation}
                                            onChange={(e) => setDesignation(e.target.value)}

                                        />
                                    </div>
                                </div>{" "}
                            </div>
                        </div>
                    </div>

                    <div className="childIssueses my-2">
                        {id == "" ? <button className="btn-btn btn btn-btn2 btn-sm me-2" onClick={DesignationSave}>
                            Save
                        </button> :
                            <button className="btn-btn btn btn-btn2 btn-sm me-2" onClick={DesignationUpdate}>
                                Update
                            </button>
                        }

                        <button
                            className="btn-btn btn btn-btn1 btn-sm"
                            onClick={() => {
                                setDesignation("");
                                onclose();
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>)
}

export default DepartmentPopUp